import { render, staticRenderFns } from "./ExamPlanForm.vue?vue&type=template&id=9bf1880e&scoped=true"
import script from "./ExamPlanForm.vue?vue&type=script&lang=js"
export * from "./ExamPlanForm.vue?vue&type=script&lang=js"
import style0 from "./ExamPlanForm.vue?vue&type=style&index=0&id=9bf1880e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf1880e",
  null
  
)

export default component.exports